<template>
    <div class="c-event c-event--view">
        <EventHeader :title="event.title" :featured_image="event.featured_image" />

        <div class="c-event__content-wrapper">
            <div class="grid-container">
                <div class="grid-x grid-margin-x align-center">
                    <div class="small-12 medium-5 large-3 cell">
                        <EventMeta
                            :royal_event="event.royal_event"
                            :park="event.park"
                            :date="event.date"
                            :time="event.time"
                            :additional_link="event.additional_link"
                            :enable_book_stay_button="event.enable_book_stay_button" />
                    </div>

                    <div class="small-12 medium-7 large-7 cell">
                        <div class="c-event__content s-wp-cms" v-html="event.content"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div
        v-if="event.park && relatedPark.tripadvisor_widget && relatedPark.tripadvisor_script"
        class="single-event__reviews">
        <EventReviews
            :tripadvisor="relatedPark.tripadvisor_widget"
            :tripadvisor_script="relatedPark.tripadvisor_script" />
    </div>
</template>

<script setup>
    const route = useRoute();
    const event = useState("event", () => null);
    const relatedPark = ref(null);

    const getEvent = async (slug) => {
        const { data } = await useFetch(`/api/wp/event/${slug}`);

        // Check if data is empty or undefined
        if (!data || !data.value || data.value.length === 0) {
            // console.log('No data found for the given route:', route.fullPath);

            throw createError({
                statusCode: 404,
                statusMessage: "Page Not Found",
            });
        }

        event.value = data;

        // console.log("Event: ", event.value);
    };

    const getRelatedPark = async (park) => {
        // console.log(park);

        const { data } = await useFetch(`/api/wp/event/park/${park}`);

        // console.log("Related Park Data: ", data.value);

        relatedPark.value = data.value;
    };

    await getEvent(route.params.post[0]);

    const getCanonicalURL = () => {
        const requestUrl = useRequestURL();

        if (event.value?.seo_canonical) {
            const url = new URL(event.value.seo_canonical);
            return requestUrl.origin + "/" + url.pathname.replace(/^\/|\/$/g, "") + "/";
        }

        return null;
    };

    if (event.value) {
        useSeoMeta({
            title: event.value.seo_title ?? event.value.seo_og_title,
            ogTitle: event.value.seo_og_title ?? event.value.seo_title,
            ogDescription: event.value.seo_og_description ?? event.value.seo_description ?? event.value.excerpt,
            description: event.value.seo_description ?? event.value.seo_og_description ?? event.value.excerpt,
            twitterCard: event.value.seo_twitter_card,
            ogSiteName: event.value.seo_og_site_name,
            ogType: event.value.seo_og_type,
            ogLocale: event.value.seo_og_locale,
            ogImage:
                event.value?.seo_og_image && event.value?.seo_og_image.length
                    ? event.value?.seo_og_image[0].url
                    : event.value.featured_image_url,
            robots: event.value.seo_robots ? Object.values(event.value.seo_robots).join(", ") : null,
            articleModifiedTime: event.value.seo_og_article_modified_time,
            ogUrl: getCanonicalURL(),
        });
    }

    if (getCanonicalURL()) {
        useHead({
            link: [
                {
                    rel: "canonical",
                    href: getCanonicalURL(),
                },
            ],
        });
    }

    if (event.value.park) {
        await getRelatedPark(event.value.park.ID);
    }
</script>
